// extracted by mini-css-extract-plugin
module.exports = {"view":"ViewList_view__24HPQ"};